<template>
    <v-dialog v-model="dialog" :scrim="false" scrollable>
        <template v-slot:activator="{props}">
            <v-btn variant="flat" v-bind="props">
                <v-icon>mdi-pencil</v-icon>
                {{ $t('admin.code') }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-white bg-primary">
                {{ $t('admin.code') }}
            </v-card-title>
            <v-card-text>
                <div ref="editor" class="wrapper full-width" />
            </v-card-text>
            <v-card-actions>
                <v-btn variant="flat" color="primary" @click="save">
                    {{ $t('ok') }}
                </v-btn>
                <v-btn variant="text" @click="dialog = false">{{ $t('cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, VModel, Vue, Watch} from 'vue-facing-decorator'
    import loader from '@monaco-editor/loader'
    import {timeout} from '@/utils/helpers'

    @Component
    export class CodeEditorDialog extends Vue {
        @VModel() html

        dialog = false
        editor = null

        @Watch('dialog')
        async onDialogChange(dialog) {
            if (!dialog) return
            const value = this.html
            await this.$nextTick()
            const monaco = await loader.init()
            this.editor = monaco.editor.create(this.$refs.editor, {
                value,
                language: 'text/html',
                autoIndent: true,
                formatOnPaste: true,
                formatOnType: true,
            })
            await timeout(100)
            await this.editor.getAction('editor.action.formatDocument').run()
        }

        save() {
            this.html = toRaw(this.editor).getValue()
            this.dialog = false
        }
    }

    export default CodeEditorDialog
</script>

<style scoped lang="scss">
    .wrapper {
        min-height: 60vh;
    }
</style>
